import { useEffect, useState } from "react";
import { Trash2, Pencil } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";

const EMPTY = { name: "", tier_label: "Corridor Sponsor", tagline: "", description: "", cta_label: "Request a briefing", website: "", contact_email: "" };

export const AdminSponsors = () => {
  const [items, setItems] = useState([]);
  const [f, setF] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const load = () => api.get("/admin/sponsors").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const create = async (e) => {
    e.preventDefault();
    const payload = { ...f, contact_email: f.contact_email || null };
    try {
      if (editId) await api.put(`/admin/sponsors/${editId}`, payload); else await api.post("/admin/sponsors", payload);
      toast.success(editId ? "Sponsor updated" : "Sponsor added"); setF(EMPTY); setEditId(null); load();
    } catch (err) { toast.error(formatApiError(err)); }
  };
  const remove = async (s) => {
    if (!window.confirm(`Remove ${s.name}? Their placements will be cleared.`)) return;
    await api.delete(`/admin/sponsors/${s.id}`); load();
  };

  return (
    <div className="grid lg:grid-cols-12 gap-8" data-testid="admin-sponsors">
      <div className="lg:col-span-7 space-y-4">
        {items.map((s) => (
          <div key={s.id} className="bg-white border border-[#DADADA] p-5 flex justify-between gap-4" data-testid={`admin-sponsor-${s.id}`}>
            <div>
              <p className="overline !text-[9px] text-[#E5332A]">{s.tier_label}</p>
              <p className="font-display text-lg font-bold">{s.name}</p>
              <p className="text-sm text-[#575757]">{s.tagline}</p>
              <p className="text-xs mt-2 font-mono-d">{s.article_count} articles · {s.lead_count} leads</p>
              <p className="text-xs mt-1 text-[#575757]" data-testid={`admin-sponsor-email-${s.id}`}>{s.contact_email ? `Lead alerts → ${s.contact_email}` : "No alert email set — leads stay in the dashboard"}</p>
            </div>
            <div className="flex gap-3 self-start">
              <button data-testid={`admin-sponsor-edit-${s.id}`} onClick={() => { setEditId(s.id); setF({ ...EMPTY, ...s, contact_email: s.contact_email || "" }); }}><Pencil size={16} /></button>
              <button data-testid={`admin-sponsor-delete-${s.id}`} onClick={() => remove(s)} className="text-[#E5332A]"><Trash2 size={16} /></button>
            </div>
          </div>
        ))}
      </div>
      <form onSubmit={create} className="lg:col-span-5 bg-white border border-[#E7E7E7] p-6 space-y-3 h-fit" data-testid="admin-sponsor-form">
        <p className="font-display text-xl font-bold">{editId ? "Edit sponsor" : "Add sponsor"}</p>
        <Input data-testid="sponsor-form-name" required placeholder="Company name" value={f.name} onChange={set("name")} className="rounded-none" />
        <Input data-testid="sponsor-form-label" placeholder="Placement label (e.g. Intelligence Partner)" value={f.tier_label} onChange={set("tier_label")} className="rounded-none" />
        <Input data-testid="sponsor-form-tagline" placeholder="Tagline" value={f.tagline} onChange={set("tagline")} className="rounded-none" />
        <Input data-testid="sponsor-form-description" placeholder="Short description" value={f.description} onChange={set("description")} className="rounded-none" />
        <Input data-testid="sponsor-form-cta" placeholder="Lead form button label" value={f.cta_label} onChange={set("cta_label")} className="rounded-none" />
        <Input placeholder="Website" value={f.website} onChange={set("website")} className="rounded-none" />
        <Input data-testid="sponsor-form-contact-email" type="email" placeholder="Lead alert email (sponsor's inbox)" value={f.contact_email} onChange={set("contact_email")} className="rounded-none" />
        <button data-testid="sponsor-form-submit" className="w-full bg-[#0A0A0A] text-white py-3 text-sm hover:bg-[#E5332A]">{editId ? "Save changes" : "Add sponsor"}</button>
        {editId && <button type="button" onClick={() => { setEditId(null); setF(EMPTY); }} className="w-full text-sm text-[#575757] py-1">Cancel edit</button>}
      </form>
    </div>
  );
};
